import React from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

const Layout = ({ children, props }) => {
  const { user } = props;

  return (
    <>
      <Navbar {...props} />
      <div className="flex">
        {user.role !== "staff" && <Sidebar {...props} />}
        <div
          className={`admin-container flex-grow p-10 overflow-x-auto ${
            user.role === "staff" && "bg-slate-200 p-0 py-4 h-dvh"
          }`}
        >
          {children}
        </div>
      </div>
    </>
  );
};

export default Layout;
